module.exports = __webpack_public_path__ + "static/media/BG.8a0211a8.svg";